export const IntegrationSources = ["none", "ALL Hotel Sales Funnel"] as const;

export type IntegrationSource = (typeof IntegrationSources)[number];

export const SessionIntegrationSources = [
  "ALL Hotel Sales Funnel",
] as const satisfies readonly Exclude<IntegrationSource, "none">[];

export type SessionIntegrationSource =
  (typeof SessionIntegrationSources)[number];

export function isSessionIntegrationSource(
  source: IntegrationSource,
): source is SessionIntegrationSource {
  return source !== "none";
}
